import { connect } from 'react-redux';
import TransferFundsBlock from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(TransferFundsBlock);
